import React, { useState } from 'react';
import fonts from 'styles/typography.module.css';
import { PencilIcon } from '@heroicons/react/24/solid';
import PendingInvitationDialog from './PendingInvitationDialog';
import UserAvatar from '../UserAvatar';

const PendingMember: React.FC<{ member: string; refreshPending: () => void }> = ({
  member,
  refreshPending,
}) => {
  const [displayIcon, setDisplayIcon] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const close = () => {
    setDialogOpen(false);
    refreshPending();
  };
  return (
    <div className={fonts.font}>
      <div
        onMouseEnter={() => setDisplayIcon(true)}
        onMouseLeave={() => setDisplayIcon(false)}
        onClick={() => setDialogOpen(true)}
        key={member}
        className="p-4 flex w-full justify-between items-center hover:bg-blue-100"
      >
        <div className="flex space-x-4 items-center">
          <UserAvatar size="small" letters={member[0].toUpperCase()} />
          <div className="flex flex-col space-y-1">
            <h4 className="text-dark">{member}</h4>
            <h5 className="uppercase text-orange-900 font-bold">Pending Invitation</h5>
          </div>
        </div>
        {displayIcon && <PencilIcon className="cursor-pointer h-4" />}
      </div>
      <PendingInvitationDialog isOpen={isDialogOpen} close={close} member={member} />
    </div>
  );
};
PendingMember.displayName = 'Settings.Profile.CompanyMembers.PendingMember';
export default PendingMember;
